var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileText(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    stroke: "#868686",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "file-text"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M12.833 3.15039V6.81706C12.833 7.32332 13.2434 7.73372 13.7497 7.73372H17.4163"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.583 19.6504H6.41634C5.40382 19.6504 4.58301 18.8296 4.58301 17.8171V4.98372C4.58301 3.9712 5.40382 3.15039 6.41634 3.15039H12.833L17.4163 7.73372V17.8171C17.4163 18.8296 16.5955 19.6504 15.583 19.6504Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    d: "M8.25 8.65041H9.16667"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    d: "M8.25 12.317H13.75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    d: "M8.25 15.9837H13.75"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileText);
export default __webpack_public_path__ + "static/media/file-text.80e045b5bad26b769989d99b9ab928a8.svg";
export { ForwardRef as ReactComponent };